import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { loadMicroApp } from '@central-products/script-module-loader';
import { ErrorTypes, HiddenMarketsWidgetFlowInterface, StateTypes } from '@central-products/interface-hidden-markets-widget-flow';
import { Environment, Jurisdiction } from './types';

// tslint:disable-next-line
var noop = function noop() {};

export var HiddenMarketsWidgetFlow = /*#__PURE__*/function (_HiddenMarketsWidgetF) {
  _inherits(HiddenMarketsWidgetFlow, _HiddenMarketsWidgetF);

  var _super = _createSuper(HiddenMarketsWidgetFlow);

  function HiddenMarketsWidgetFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, HiddenMarketsWidgetFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.STOPPED);

    _defineProperty(_assertThisInitialized(_this), "startSuccess", noop);

    _defineProperty(_assertThisInitialized(_this), "startError", noop);

    _defineProperty(_assertThisInitialized(_this), "stopSuccess", noop);

    _defineProperty(_assertThisInitialized(_this), "stopError", noop);

    _defineProperty(_assertThisInitialized(_this), "stateChanged", noop);

    if (!config.environment || _Object$values(Environment).indexOf(config.environment) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ENVIRONMENT
      };
    }

    if (!config.jurisdiction || _Object$values(Jurisdiction).indexOf(config.jurisdiction) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_JURISDICTION
      };
    }

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(HiddenMarketsWidgetFlow, [{
    key: "onStartSuccess",
    value: function onStartSuccess(callback) {
      var _this2 = this;

      this.startSuccess = callback; // unsubscribe on call

      return function () {
        _this2.startSuccess = noop;
      };
    }
  }, {
    key: "onStartError",
    value: function onStartError(callback) {
      var _this3 = this;

      this.startError = callback; // unsubscribe on call

      return function () {
        _this3.startError = noop;
      };
    }
  }, {
    key: "onStopSuccess",
    value: function onStopSuccess(callback) {
      var _this4 = this;

      this.stopSuccess = callback; // unsubscribe on call

      return function () {
        _this4.stopSuccess = noop;
      };
    }
  }, {
    key: "onStopError",
    value: function onStopError(callback) {
      var _this5 = this;

      this.stopError = callback; // unsubscribe on call

      return function () {
        _this5.stopError = noop;
      };
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      var _this6 = this;

      this.stateChanged = callback; // unsubscribe on call

      return function () {
        _this6.stateChanged = noop;
      };
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var containerSelector, domNode, _this$config, jurisdiction, environment, locale, microAppLoaderConfig, openResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerSelector = _ref.containerSelector;
                _context.prev = 1;
                domNode = document.querySelector(containerSelector);

                if (!(this.state === StateTypes.STARTED)) {
                  _context.next = 5;
                  break;
                }

                throw {
                  error: ErrorTypes.HIDDEN_MARKETS_ALREADY_STARTED
                };

              case 5:
                if (containerSelector) {
                  _context.next = 7;
                  break;
                }

                throw {
                  error: ErrorTypes.MISSING_PARAM_CONTAINER_SELECTOR
                };

              case 7:
                if (domNode) {
                  _context.next = 9;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_FIND_DOM_NODE_FOR_HIDDEN_MARKETS
                };

              case 9:
                _this$config = this.config, jurisdiction = _this$config.jurisdiction, environment = _this$config.environment, locale = _this$config.locale;
                microAppLoaderConfig = {
                  name: 'hidden-markets',
                  environment: environment,
                  jurisdiction: jurisdiction,
                  dependencies: {
                    React: React,
                    ReactDOM: ReactDOM
                  }
                };
                _context.next = 13;
                return loadMicroApp(microAppLoaderConfig);

              case 13:
                openResult = window.WH['cp-apps']['hidden-markets'].open({
                  jurisdiction: jurisdiction,
                  locale: locale,
                  environment: environment,
                  graphqlClient: this.dependencies['data-access-service']
                }, domNode);

                if (!(openResult === undefined)) {
                  _context.next = 16;
                  break;
                }

                throw {
                  error: ErrorTypes.HIDDEN_MARKETS_ALREADY_STARTED
                };

              case 16:
                if (!(openResult === false)) {
                  _context.next = 18;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_START_HIDDEN_MARKETS
                };

              case 18:
                this.changeState(StateTypes.STARTED);
                this.startSuccess();
                return _context.abrupt("return", _Promise.resolve({}));

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](1);
                this.startError(_context.t0);
                return _context.abrupt("return", _Promise.reject(_context.t0));

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 23]]);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var closeResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(this.state === StateTypes.STOPPED)) {
                  _context2.next = 3;
                  break;
                }

                throw {
                  error: ErrorTypes.HIDDEN_MARKETS_ALREADY_STOPPED
                };

              case 3:
                closeResult = window.WH['cp-apps']['hidden-markets'].close();

                if (!(closeResult === undefined)) {
                  _context2.next = 6;
                  break;
                }

                throw {
                  error: ErrorTypes.HIDDEN_MARKETS_ALREADY_STOPPED
                };

              case 6:
                if (!(closeResult === false)) {
                  _context2.next = 8;
                  break;
                }

                throw {
                  error: ErrorTypes.COULD_NOT_STOP_HIDDEN_MARKETS
                };

              case 8:
                this.changeState(StateTypes.STOPPED);
                this.stopSuccess();
                return _context2.abrupt("return", _Promise.resolve({}));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                this.stopError(_context2.t0);
                return _context2.abrupt("return", _Promise.reject(_context2.t0));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _Promise.resolve({
                  state: this.state
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "changeState",
    value: function changeState(state) {
      if (state !== this.state) {
        this.state = state;

        if (this.stateChanged) {
          this.stateChanged({
            state: state
          });
        }
      }
    }
  }]);

  return HiddenMarketsWidgetFlow;
}(HiddenMarketsWidgetFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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